import app from 'flarum/forum/app';
import {extend} from "flarum/common/extend";
import UserPage from "flarum/forum/components/UserPage";
import LinkButton from "flarum/common/components/LinkButton";
import UserCard from "flarum/forum/components/UserCard";
import {getOrLoadPlayerData, getPlayerData, hasPlayerData} from "../SteamProfiles";
import SettingsPage from "flarum/forum/components/SettingsPage";
import Button from "flarum/common/components/Button";
import {linkQQ, unlinkQQ} from "../QQAuth";

export default function() {
  extend(UserPage.prototype, "navItems", function(items) {
    const user = this.user;
    items.add("zs_data", LinkButton.component({
      href: app.route("user.zs_data", {username: user?.slug()}),
      name: "zsdata",
      icon: "fas fa-biohazard"
    }, app.translator.trans("rhodes-island.forum.user.zs_data_link")), 70);
    items.add("scp_data", LinkButton.component({
      href: app.route("user.scp_data", {username: user?.slug()}),
      name: "scpdata",
      icon: "fas fa-theater-masks"
    }, app.translator.trans("rhodes-island.forum.user.scp_data_link")), 69);
  });
  extend(UserCard.prototype, "oncreate", function() {
    const steamId = (this.attrs as any).user.data.attributes.steamID;
    if (steamId) {
      getOrLoadPlayerData(steamId).then(() => m.redraw());
    }
  });
  extend(UserCard.prototype, "infoItems", function(items) {
    const steamId = (this.attrs as any).user.data.attributes.steamID;
    if (steamId) {
      if (hasPlayerData(steamId)) {
        let ply = getPlayerData(steamId);
        items.add("steam", <a target="_blank" href={ply.profileurl}>
        <i class="fab fa-steam"/>
          &nbsp;
        {ply.personaname}
        </a>, 200);
      } else {
        items.add("steamid", <a target="_blank" href={`https://steamcommunity.com/profiles/${steamId}`} title="SteamID64"><i class="fab fa-steam"/>&nbsp;{steamId}</a>, 200);
      }
    }
  });
  extend(SettingsPage.prototype, "accountItems", function(items) {
    items.remove("changePassword");
    items.add("qqLink", this.user?.attribute("qqLinked") ? <Button className="Button" onclick={() => unlinkQQ()}>
      {app.translator.trans('rhodes-island.forum.qq.unlink')}
    </Button> : <Button className="Button" onclick={() => linkQQ()}>
      {app.translator.trans('rhodes-island.forum.qq.link')}
    </Button>, -10);
  });
}
